<!-- Toast notifications -->
<p-toast key="nurse-details"></p-toast>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="nurse-details-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="nurse-details-title">
          <i class="pi pi-user mr-3"></i>
          My Profile
        </h1>
        <p class="nurse-details-subtitle">
          Manage your professional information and account details
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="m-4 nurse-details-content">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        styleClass="loading-spinner"
      ></p-progressSpinner>
      <p class="loading-text">Loading profile details...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading" class="profile-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="modern-form">
      <!-- Professional Information Section -->
      <div class="content-section">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-id-card mr-2"></i>
              Professional Information
            </h2>
            <p class="section-description">
              Your nursing credentials and professional details
            </p>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-field">
            <label class="form-label" for="sanc_number">
              <i class="pi pi-certificate mr-1"></i>
              SANC Number *
            </label>
            <input
              id="sanc_number"
              type="text"
              formControlName="sanc_number"
              class="modern-input"
              placeholder="Enter your SANC registration number"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('sanc_number')?.invalid &&
                form.get('sanc_number')?.touched
              "
            >
              <span class="error-text">SANC Number is required</span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="practice_number">
              <i class="pi pi-building mr-1"></i>
              Practice Number *
            </label>
            <input
              id="practice_number"
              type="text"
              formControlName="practice_number"
              class="modern-input"
              placeholder="Enter your practice number"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('practice_number')?.invalid &&
                form.get('practice_number')?.touched
              "
            >
              <span class="error-text">Practice Number is required</span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="sanc_qualification">
              <i class="pi pi-graduation-cap mr-1"></i>
              SANC Qualification *
            </label>
            <input
              id="sanc_qualification"
              type="text"
              formControlName="sanc_qualification"
              class="modern-input"
              placeholder="Enter your SANC qualification"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('sanc_qualification')?.invalid &&
                form.get('sanc_qualification')?.touched
              "
            >
              <span class="error-text">SANC Qualification is required</span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="contact_number">
              <i class="pi pi-phone mr-1"></i>
              Contact Number *
            </label>
            <input
              id="contact_number"
              type="tel"
              formControlName="contact_number"
              class="modern-input"
              placeholder="Enter your contact number"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('contact_number')?.invalid &&
                form.get('contact_number')?.touched
              "
            >
              <span class="error-text">Contact Number is required</span>
            </div>
          </div>
          <div class="form-field">
            <label class="form-label" for="contact_number">
              <i class="pi pi-phone mr-1"></i>
              Alternate Contact Number *
            </label>
            <input
              id="contact_number"
              type="tel"
              formControlName="alternate_contact_number"
              class="modern-input"
              placeholder="Enter your contact number"
            />
          </div>
        </div>
      </div>

      <!-- Personal Information Section -->
      <div class="content-section" formGroupName="user">
        <div class="section-header">
          <div class="header-info">
            <h2 class="section-title">
              <i class="pi pi-user mr-2"></i>
              Personal Information
            </h2>
            <p class="section-description">Your account and personal details</p>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-field">
            <label class="form-label" for="username">
              <i class="pi pi-hashtag mr-1"></i>
              Username *
            </label>
            <input
              id="username"
              type="text"
              formControlName="username"
              class="modern-input"
              placeholder="Enter your username"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('user.username')?.invalid &&
                form.get('user.username')?.touched
              "
            >
              <span class="error-text">Username is required</span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="email">
              <i class="pi pi-envelope mr-1"></i>
              Email Address *
            </label>
            <input
              id="email"
              type="email"
              formControlName="email"
              class="modern-input"
              placeholder="Enter your email address"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('user.email')?.invalid &&
                form.get('user.email')?.touched
              "
            >
              <span class="error-text">
                <span *ngIf="form.get('user.email')?.errors?.['required']"
                  >Email is required</span
                >
                <span *ngIf="form.get('user.email')?.errors?.['email']"
                  >Please enter a valid email address</span
                >
              </span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="first_name">
              <i class="pi pi-user mr-1"></i>
              First Name *
            </label>
            <input
              id="first_name"
              type="text"
              formControlName="first_name"
              class="modern-input"
              placeholder="Enter your first name"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('user.first_name')?.invalid &&
                form.get('user.first_name')?.touched
              "
            >
              <span class="error-text">First Name is required</span>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label" for="last_name">
              <i class="pi pi-user mr-1"></i>
              Last Name *
            </label>
            <input
              id="last_name"
              type="text"
              formControlName="last_name"
              class="modern-input"
              placeholder="Enter your last name"
            />
            <div
              class="error-message"
              *ngIf="
                form.get('user.last_name')?.invalid &&
                form.get('user.last_name')?.touched
              "
            >
              <span class="error-text">Last Name is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="submit"
          pButton
          pRipple
          label="Update Profile"
          icon="pi pi-save"
          class="modern-button primary"
          [disabled]="form.invalid || isSubmitting"
          [loading]="isSubmitting"
        ></button>
      </div>
    </form>
  </div>
</div>
